// Alert.tsx
import React from 'react';
import {
  Alert as ChakraAlert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Box,
  Button,
  Stack,
} from '@chakra-ui/react';

export type AlertSeverity = 'info' | 'warning' | 'error' | 'success';

export interface AlertAction {
  label: string;
  handler: (() => void) | null;
}

export interface AlertProps {
  severity: AlertSeverity;
  title: string;
  message: string;
  actions?: AlertAction[];
  onClose: () => void;
}

const Alert: React.FC<AlertProps> = ({ severity, title, message, actions, onClose }) => {
  return (
    <Box
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      bg="rgba(0, 0, 0, 0.5)"
      zIndex="9999"
      onClick={onClose}
    >
      <Box
        position="absolute"
        top="300px"
        left="50%"
        transform="translate(-50%, -50%)"
        bg="white"
        borderRadius="md"
        boxShadow="lg"
        maxWidth="400px"
        width="100%"
        p={4}
        onClick={(e) => e.stopPropagation()}
      >
        <ChakraAlert status={severity} borderRadius="md">
          <AlertIcon />
          <Box flex="1">
            <AlertTitle>{title}</AlertTitle>
            <AlertDescription>{message}</AlertDescription>
          </Box>
        </ChakraAlert>
        <Stack direction="row" spacing={2} mt={4} justifyContent="flex-end">
          {actions?.map((action, index) => (
            <Button key={index} onClick={action.handler || onClose}>
              {action.label}
            </Button>
          )) || (
            <Button onClick={onClose}>Ok</Button>
          )}
        </Stack>
      </Box>
    </Box>
  );
};

export default Alert;